import { useEffect, useRef } from "react";
import { useForm } from "react-hook-form";

const DeleteDPModal = ({ machine_id, handleWORemove }) => {
    const closeBtnRef = useRef(null);

    const {
        handleSubmit,
        register,
        reset,
        formState: { errors },
    } = useForm({ mode: "onBlur" });

    const handleCloseModal = () => {
        if (closeBtnRef.current) {
            closeBtnRef.current?.click();
        }
    };

    const onSubmit = (data) => {
        console.log(data);
        handleWORemove();
        reset();
        handleCloseModal();
    };

    useEffect(() => {
        return () => {
            const backdrop = document.querySelector(".modal-backdrop");
            if (backdrop) {
                backdrop.remove();
                document.body.classList.remove("modal-open");
                document.body.style = "";
            }
        };
    }, []);

    return (
        <div
            className="modal fade m-0 p-0"
            tabIndex={-1}
            id={`delete-wo-modal-${machine_id}`}
            aria-modal
        >
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <button
                        type="button"
                        className="close"
                        data-bs-dismiss="modal"
                        ref={closeBtnRef}
                    >
                        <em
                            className="icon ni ni-cross"
                            aria-hidden="true"
                        ></em>
                    </button>
                    <div className="modal-header">
                        <h5 className="modal-title">Delete daily plan</h5>
                    </div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-sm-12">
                                    <label className="form-label">
                                        Reason
                                        <span className="fs-8 text-danger ms-1">
                                            *
                                        </span>
                                    </label>
                                    <textarea
                                        className="form-control"
                                        placeholder="Reason..."
                                        id="text-forms-reason"
                                        {...register("reason", {
                                            required: "Reason is required",
                                        })}
                                    ></textarea>
                                    {errors.reason && (
                                        <span className="text-danger">
                                            {errors.reason.message}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer bg-light">
                            <button
                                type="button"
                                className="btn btn-danger"
                                data-bs-dismiss="modal"
                            >
                                Cancel
                            </button>
                            <button type="submit" className="btn btn-primary">
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default DeleteDPModal;
